import React from 'react';

import AssetList from '../../AssetList/index.jsx';
import CMSContent from '../../CMSContent/index.jsx';

import ContentFeed from '../ContentFeed/index.jsx';
import PortfolioBreakdown from '../PortfolioBreakdown/index.jsx';
import PortfolioTotals from '../PortfolioTotals/index.jsx';


class Dashboard extends React.Component {
  render() {
    var content;

    if (
      ! (this.props.assets && this.props.assets.length) &&
      ! (this.props.blockchains && this.props.blockchains.length) &&
      ! (this.props.categories && this.props.categories.length)
    ) {
      content = (
        <p>Select some areas of interest to get started.</p>
      );
    } else {
      content = [];
      var assets;
      var news = [];
      var portfolio;

      news.push(
        <h2
          key="heading"
          dangerouslySetInnerHTML={{ __html: 'Research &amp; Analysis' }}
        />
      );
      news.push(
        <ContentFeed
          key="feed"
          assets={this.props.assets}
          blockchains={this.props.blockchains}
          categories={this.props.categories}
        />
      );

      if (this.props.assets?.length) {
        portfolio = (
          <div className="cs-dashboard__portfolio-breakdown">
            <CMSContent variants="template">
              <PortfolioBreakdown
                  key={`breakdown-${this.props.portfolioId}`}
                  portfolios={[{
                    id: this.props.portfolioId,
                    assets: this.props.assets
                  }]}
                  title={`Breakdown of ${this.props.name}`}
              />
            </CMSContent>
          </div>
        );

        assets = (
          <div className="cs-dashboard__assets">
            <CMSContent variants="template">
              <div className="cs-block-asset-list">
                <AssetList assets={this.props.assets} showPortfolio portfolioId={this.props.portfolioId} />  
              </div>
              <PortfolioTotals portfolioId={this.props.portfolioId}/> 
            </CMSContent>
          </div>
        );
      }

      content.push(
        <div key="content" className="cs-dashboard">
          <div className="cs-dashboard__grid">
            {assets}
            {portfolio}
            <div className="cs-dashboard__news">
              <CMSContent variants="template">
                {news}
              </CMSContent>
            </div>
          </div>
        </div>
      );
    }


    return content;
  }
}


export default Dashboard;

